

function report(data, timeCost, url, opts) {
}


export { report };
